import React from 'react'

import './Loading.css'

const Loading = ({label, size, relative}) => {
  let spinnerSize = { width: '50px', height: '50px' }
  if( size === 'small' ) spinnerSize = { width: '25px', height: '25px' }

  return(
    <div className={ "loading " + size } style={ relative ? {position: 'relative', minHeight: '150px'} : {} }>
      <div className="loading-container">
        <svg className="spinner" width={spinnerSize.width} height={spinnerSize.height} viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
          <circle className="path" fill="none" strokeWidth="6" strokeLinecap="round" cx="33" cy="33" r="30"></circle>
        </svg>
      </div>
    </div>
  )
}

export default Loading
